
/**
 * @fileOverview Equal Columns module definition
 * @author
 * @modified 11/24/2014
 **/
(function(context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('kungfu/equalColumns/equalColumns',['require','jquery','GlobalEventDispatcher','GlobalResizeListener','lib/Util'],function(require) {
        var $ = require('jquery'),
            GlobalEventDispatcher = require('GlobalEventDispatcher'),
            GlobalResizeListener = require('GlobalResizeListener'),
            Util = require('lib/Util');

        require(['domReady!'], function(doc) {
            /*Fires upon DOM Ready to initialize component*/
            $debug('**** EqualColumns Set Up Started **** ', 'mmmEqualColumns');

            $('.js-eqColumn').each(function(i, el) {
                $debug('EqualColumns Block #' + (i + 1), 'mmmEqualColumns');
                new EqualColumns($(this));
            });

            //allow dynamic equal columns to be added to page. Requires jQuery selector to be passed in
            var selector = 'js-eqColumn';
            window.updateColumnsEqHeight = function(sel){
                if (!sel){
                    $debug('selector no set... setting it to ' + selector, 'mmmEqualColumns');
                    sel = selector;
                }
                else{
                    $debug('selector set to ' + sel, 'mmmEqualColumns');
                }

                $('.js-eqColumn').each(function (i,element) {
                    $debug('updateColumnsEqHeight EqualColumns Block #' + (i + 1), 'mmmEqualColumns');
                    new EqualColumns($(element));
                });
            };

        });

        $debug('EqualColumns loaded - use ?debug=EqualColumns for messages');

        /**
         * @class EqualColumns (js-eqColumn)
         * @param {jQuery} $element A reference to the containing DOM element.
         * @constructor
         */
        var EqualColumns = function($element) {
            /**
             * A reference to the containing DOM element.
             *
             * @default null
             * @property $element
             * @type {jQuery}
             * @public
             */
            this.$element = $element;
            this.$filterBox = this.$element.find($('.MMM--filterBox'));


            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalEventDispatcher.getEventDispatcher()
             * @property GlobalEventDispatcher
             * @type {jQuery}
             */
            this.eventDispatcher = GlobalEventDispatcher.getEventDispatcher();

            /**
             * The global instance of an event dispatcher, used to subscribe to or publish events of global interest
             *
             * @default GlobalResizeListener.getResizeListener()
             * @property GlobalResizeListener
             * @type {jQuery}
             */
            this.globalResizeListener = GlobalResizeListener.getResizeListener();

            /**
             * Tracks whether component is enabled.
             *
             * @default false
             * @property isEnabled
             * @type bool
             */
            this.isEnabled = false;
            this.init();
        };

        /**
         * Initializes the UI Component View.
         * Runs a single setupHandlers call, followed by createChildren and layout.
         * Exits early if it is already initialized.
         *
         * @method init
         * @returns {MediaController}
         * @private
         */
        EqualColumns.prototype.init = function() {
           // this.context = this.globalResizeListener.getCurrentContext();
            this
                .setOptions()
                .build()
                .enable()
                .setupHandlers()
                .resizeCheck();

            return this;
        };

        /**
         * This sets the options via data-options in the html markup. If
         * the options aren't set it goes to the defaults.
         * Syntax for HTML should be data-options='{"enabled" : false}'
         *
         * @method setOptions
         * @returns {EqualColumns}
         * @private
         */
        EqualColumns.prototype.setOptions = function() {
            var options = this.$element.data().options;
            var defaults = {
                enabled: true,
                height_sel: ''
            };

            options = {
                height_sel: this.$element.data().height_sel
            };
            
            // If an array was specified, parse it out of the string
            if (options.height_sel.indexOf('[') === 0 && options.height_sel.indexOf(']')+1 === options.height_sel.length) {
                options.height_sel = JSON.parse(this.$element.data().height_sel.replace(/'/g, '\"'));
            }

            this.settings = $.extend({}, defaults, options);

            $debug('     EqualColumns Options ', 'mmmEqualColumns');
            $debug('     HTML data-options Settings: ' + $printObj(options), 'mmmEqualColumns');
            $debug('     Default Settings: ' + $printObj(defaults), 'mmmEqualColumns');
            $debug('     Combined Settings: ' + $printObj(this.settings), 'mmmEqualColumns');

            return this;
        };

        /**
         * Enables the component.
         * Performs any event binding to handlers.
         * Exits early if it is already enabled.
         *
         * @method enable
         * @returns {EqualColumns}
         * @public
         */
        EqualColumns.prototype.enable = function() {
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            return this;
        };

        /**
         * Disables the component.
         * Tears down any event binding to handlers.
         * Exits early if it is already disabled.
         *
         * @method disable
         * @returns {EqualColumns}
         * @public
         */
        EqualColumns.prototype.disable = function() {
            if (!this.isEnabled) {
                return this;
            }
            this.isEnabled = false;

            return this;
        };

        /**
         * Builds the component
         * Performs any event binding to handlers
         * Exits early if it is already enabled
         *
         * @method build
         * @returns {adjustHeight}
         * @public
         */
        EqualColumns.prototype.build = function() {
            if (this.isEnabled) {
                return this;
            }
            this.isEnabled = true;

            this.context = this.globalResizeListener.getCurrentContext();

            var self = this;

            self.equalHeight();
            self.fixMediaElement();

            //self.resizeCheck();
            return this;
        };

        /**
         * Binds the scope of any handler functions.
         * Should only be run on initialization of the view.
         *
         * @method setupHandlers
         * @returns {EqualColumns}
         * @private
         */
        EqualColumns.prototype.setupHandlers = function() {
			var self = this;
            //this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.CONTEXT_CHANGE, this.resizeCheck.bind(this));
            this.eventDispatcher.subscribe(GlobalEventDispatcher.EVENTS.WINDOW_RESIZE, this.resizeCheck.bind(this));
			
			// Run resizeCheck() on image load in case it affects row heights
			this.$element.find('img').on('load', function(e){
				self.resizeCheck();
			});
			
            return this;
        };

        EqualColumns.prototype.resizeCheck = function() {

            if (this.isEnabled === true) {
                this.context = this.globalResizeListener.getCurrentContext();
            }

            var self = this;

            //self.equalHeight();
            //$msg('in resizeCheck');
            //setTimeout(function() {
            //    self.equalHeight();
            //}, 120);
            self.equalHeight();
            self.fixMediaElement();
            //console.log($("body").outerWidth());
            return this;
        };

        /**
         * Equal Height Function definition
         */
        EqualColumns.prototype.equalHeight = function() {
            var self = this,
                ele = self.settings.height_sel,
                findEle = self.$element.find(ele),
                heights = [],
                arr = [],
                t,
                m;
            $debug('ele ==' + ele, 'mmmEqualColumns');

            if (ele !== ''){

                if (typeof ele == "string") {

                     //$msg('in string');
                     $debug('in string', 'mmmEqualColumns');
                    // Loop to get all element heights
                    $(findEle).each(function() {

                        // Need to let sizes be whatever they want so no overflow on resize
                        //$(this).css('min-height', '0');
                        //$(this).css('max-height', 'none');
                        $(this).css('height', 'auto');
                        //$debug(heights, 'mmmEqualColumns');
                        //$msg('height '+$(this).height());
                        // Then add size (no units) to array
                        heights.push(Math.ceil($(this).height()));
                    });

                    // Find max height of all elements
                    var max = Math.max.apply(Math, heights);
                    $debug('equalheight max === ' + max, 'mmmEqualColumns');
                    // Set all heights to max height
                    if (this.context === 'largeContext' || this.context === 'luxuryContext' || this.context === 'mediumContext' || $("body").outerWidth() > 500) {
                        $(findEle).each(function() {
                            $(this).css('height', max + 'px');
                        });
                    }
                } else {
                    if ($.isArray(ele) && ele !== null){

                    //$msg('in array condition');
                    //$msg('in array' + ele.length);
                    $debug('in array' + ele.length, 'mmmEqualColumns');

                        $.each(ele, function(key, value) {
                            //$msg('in array condition == ' + key  + value);
                            $debug('in array condition == ' + key  + value, 'mmmEqualColumns');
                                var h = [];
                                // Loop to get all element heights
                                self.$element.find(value).each(function() {
                                    $(this).css('height', 'auto');
                                    //$msg('height '+$(this).height());

                                    $debug('height '+$(this).height(), 'mmmEqualColumns');
                                    // Then add size (no units) to array
                                    h.push(Math.ceil($(this).height()));
                                    // Find max height of all elements
                                    //$msg('equalheight max 1111 === ' + h);
                                    $debug('equalheight h === ' + h, 'mmmEqualColumns');
                                });

                                var max = Math.max.apply(Math, h);
                                //$msg('equalheight max === ' + max);
                                $debug('equalheight max === ' + max, 'mmmEqualColumns');

                                // Set all heights to max height
                                $debug('body width: ' + $("body").outerWidth());
                                if (this.context === 'largeContext' || this.context === 'luxuryContext' || this.context === 'mediumContext' || $("body").outerWidth() > 500) {
                                    self.$element.find(value).each(function() {
                                        $(this).css('height', max + 'px');
                                    });
                                }
                        });
                    }
                }
            }
        };

        /**
         * fixMediaElement Function definition - to only be used with Course Catalog
         */
        EqualColumns.prototype.fixMediaElement = function() {
            var self = this,
                ele = self.settings.height_sel;
            
            // Verify this is only used on Course Catalog
            if (self.$element.find(".js-rLrnImg").length > 0) {
                var setHeight = 205; // default if errors

                // Find auto-width for column and setHeight equal to half of the width or 205px
                self.$element.find(".MMM--media-element").css('width', 'auto');
                setHeight = Math.min(Math.ceil((self.$element.find(".MMM--media-element").width()) / 2), 205);
                $debug('Max-height element set to: ' + setHeight, 'mmmEqualColumns');

                // Add height and line-height to MMM--media-element
                self.$element.find(".MMM--media-element").each(function() {
                    $(this).css('height', setHeight + 'px');
                    // Add line-height for centering of vertical items
                    $(this).css('line-height', setHeight + 'px');
                });

                // Add height and max-height to js-rLrnImg
                self.$element.find(".js-rLrnImg").each(function() {                                        
                    $(this).css('height', 'auto');
                    $(this).css('max-height', setHeight + 'px');
                });                                                
            }
        };

        return EqualColumns;
    });

}(MMMRequire));
